// extracted by mini-css-extract-plugin
export default {"docDetails":"attachment_docDetails__JEo-2"};